export default "__VITE_ASSET__DRrcYkUz__"